/* eslint-disable */
/* eslint-disable import/prefer-default-export */
import moment from "moment";
import Flowit from "../../../services/flowit";
import * as types from "./types";

export const loadAccount = ({ commit }) => {
  Flowit.account.getBalance().then(response => {
    commit(types.BALANCE, response.data.balance);
  });
};

export const getAnticipationRule = ({ commit }) => {
  Flowit.anticipations.rule.then(response => {
    commit(types.ANTICIPATION_RULE, response.data.rule);
  });
};

export const updatePassword = ({ commit }, data) => {
  commit(types.LOADING, true);
  return Flowit.account.updatePassword(data).then(response => {
    commit(types.LOADING, false);
    //TODO RETORNAR RESPONSE PARA INFORMAR AO USUARIO QUE A SENHA FOI ALTERADA
    return response;
  }).catch(error => {
    commit(types.LOADING, false);
    throw error;
  });
};
export const isLoad = ({ commit }, param) => {
  commit(types.IS_LOAD, param);
};

export const updateAccount = ({ commit }, params) => {
  commit(types.IS_LOAD, true);
  Flowit.account
    .updateAccount(params)
    .then(response => {
      commit(types.ACCOUNT, response.data);
      commit(types.IS_LOAD, false);
      commit(types.SHOW_FORM, false);
    })
    .catch(error => {
      // console.log(error.message);
      commit(types.IS_LOAD, false);
      commit(types.SHOW_FORM, false);
    });
};
export const showError = ({ commit }, param) => {
  commit(types.SHOW_ERROR, param);
};
export const showSuccess = ({ commit }, param) => {
  commit(types.SHOW_SUCCESS, param);
};
export const activeNew = ({ commit }, param) => {
  commit(types.ACTIVE_NEW, param);
};

export const getAccount = ({ commit }) => {
  commit(types.LOADING, true);
  Flowit.account.getAccount().then(response => {
    commit(types.ACCOUNT, response.data);
    commit(types.LOGO_LINK, response.data.styles.partner_logo);
    commit(types.FAVICON, response.data.styles.partner_favicon);
    commit(types.COLOR, response.data.styles.panel_color);
    commit(types.PARTNER_NAME, response.data.fantasy_name);
    commit(types.PARTNER, response.data.partner);
    commit(types.LOADING, false);
  }).catch(error => {
    console.error('Error fetching account:', error);
    commit(types.LOADING, false);
  });
};

export const getAccountTaxes = ({ commit }, cardBrand) => {
  Flowit.account.getAccountTaxes(cardBrand).then(response => {
    commit(types.ACCOUNT_TAXES, response.data.taxes);
    commit(types.ACCOUNT_TAX_BRANDS, response.data.brands);
    commit(types.ACCOUNT_TAX_SELECTED_BRAND, response.data.selected_brand);
  });
};

export const getAccountPayers = ({ commit }) => {
  Flowit.account.getAccountPayers().then(response => {
    commit(types.ACCOUNT_PAYERS, response.data.payers);
  });
};

export const deleteAccountPayers = ({ commit }, params) => {
  Flowit.account.deleteAccountPayers(params).then(response => {
    commit(types.ACCOUNT_PAYERS, response.data.payers);
  });
};

export const newAccountPayers = ({ commit }, params) => {
  Flowit.account
    .newAccountPayers(params)
    .then(response => {
      commit(types.ACCOUNT_PAYERS, response.data.payers);
    })
    .catch(error => {
    });
};

export const sendLogo = ({ commit, dispatch }, file) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.account
    .sendLogo(file)
    .then(response => {
      commit(types.LOGO_LINK, response.data.logo_link);
      commit(types.LOAD, false);
      commit(types.SUCCESS_STATUS, true);
      commit(types.SHOW_LOGO_FORM, false);
      
      // Forçar atualização da configuração do sistema para refletir a nova logo
      setTimeout(() => {
        dispatch('system/forceUpdateSystemConfiguration', null, { root: true });
      }, 1000); // Aguardar 1 segundo para garantir que o backend processou
    })
    .catch(error => {
      commit(types.LOAD, false);
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, (error.response && error.response.data && error.response.data.message) || 'Erro ao enviar logo');
      commit(types.SHOW_LOGO_FORM, false);
    });
};

export const sendFavicon = ({ commit, dispatch }, file) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.account
    .sendFavicon(file)
    .then(response => {
      commit(types.FAVICON, response.data.favicon);
      commit(types.LOAD, false);
      commit(types.SUCCESS_STATUS, true);
      commit(types.SHOW_FAVICON_FORM, false);
      
      // Forçar atualização da configuração do sistema para refletir o novo favicon
      setTimeout(() => {
        dispatch('system/forceUpdateSystemConfiguration', null, { root: true });
      }, 1000); // Aguardar 1 segundo para garantir que o backend processou
    })
    .catch(error => {
      commit(types.LOAD, false);
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, (error.response && error.response.data && error.response.data.message) || 'Erro ao enviar favicon');
      commit(types.SHOW_FAVICON_FORM, false);
    });
};

export const sendColor = ({ commit, dispatch }, params) => {
  Flowit.account
    .sendColor(params)
    .then(response => {
      commit(types.COLOR, response.data.panel_color);
      commit(types.SHOW_COLOR_FORM, false);
      
      // Forçar atualização da configuração do sistema para refletir a nova cor
      setTimeout(() => {
        dispatch('system/forceUpdateSystemConfiguration', null, { root: true });
      }, 1000); // Aguardar 1 segundo para garantir que o backend processou
    })
    .catch(error => {
      commit(types.SHOW_COLOR_FORM, false);
    });
};

export const updateAccountPayers = ({ commit }, params) => {
  Flowit.account
    .updateAccountPayers(params)
    .then(response => {
      commit(types.ACCOUNT_PAYERS, response.data.payers);
    })
    .catch(error => {
    });
};

export const getAccountLends = ({ commit }) => {
  Flowit.account.getAccountLends().then(response => {
    commit(types.ACCOUNT_LENDS, response.data.lends);
  });
};

export const getNotifications = ({ commit }) => {
  Flowit.account.getNotifications().then(response => {
    commit(types.NOTIFICATIONS, response.data);
  });
};

export const showNotifications = ({ commit }) => {
  commit(types.NOTIFICATIONS_VISIBLE, true);
};

export const hideNotifications = ({ commit }) => {
  commit(types.NOTIFICATIONS_VISIBLE, false);
};

export const getAnticipationTax = ({ commit }) => {
  Flowit.anticipations.tax.then(response => {
    commit(types.ANTICIPATION_TAX, response.data.tax);
  });
};

export const getBalance = ({ commit }) => {
  Flowit.account.balance.then(response => {
    commit(types.BALANCE, response.data.balance);
  });
};

export const getAnticipationsAvailable = ({ commit }, params) => {
  Flowit.account.anticipationsAvailable(params).then(response => {
    commit(types.ANTICIPATIONS_AVAILABLE, response.data.resources);
    commit(types.ANTICIPATIONS_AVAILABLE_COUNT, response.data.count);
    commit(types.CURRENT_TAX, response.data.tax);
  }, params);
};

export const setSelectAnticipations = ({ commit }, anticipations) => {
  commit(types.SELECTED_ANTICIPATIONS, anticipations);
};

export const updateSelectedAnticipationsAmount = ({ commit }, amount) => {
  commit(types.SELECTED_ANTICIPATIONS_AMOUNT, amount);
};

export const updateAnticipationsAvailableLimit = ({ commit }, limit) => {
  commit(types.ANTICIPATIONS_AVAILABLE_LIMIT, limit);
};

export const updateAnticipationsAvailablePage = ({ commit }, page) => {
  commit(types.ANTICIPATIONS_AVAILABLE_PAGE, page);
};

export const showLogoForm = ({ commit }, params) => {
  commit(types.SHOW_LOGO_FORM, params);
};

export const showFaviconForm = ({ commit }, params) => {
  commit(types.SHOW_FAVICON_FORM, params);
};

export const showColorForm = ({ commit }, params) => {
  commit(types.SHOW_COLOR_FORM, params);
};
export const showForm = ({ commit }, params) => {
  commit(types.SHOW_FORM, params);
};

export const updateLiquidationAccount = ({ commit }, newValue) => {
  Flowit.account.updateLiquidationAccount(newValue).then(response => {
    // console.log(response);
  });
};

export const isBillPaymentEnabled = ({ commit, rootState }) => {
  const enabled = rootState.system.configuration.enable_bill_payments === true;
  commit(types.IS_BILL_PAYMENT_ENABLED, enabled);
};

export const isInvoicePaymentEnabled = ({ commit, rootState }) => {
  const enabled = rootState.system.configuration.enable_invoice_payments === true;
  commit(types.IS_INVOICE_PAYMENT_ENABLED, enabled);
};

export const isDarfPaymentEnabled = ({ commit, rootState }) => {
  const enabled = rootState.system.configuration.enable_darf_payments === true;
  commit(types.IS_DARF_PAYMENT_ENABLED, enabled);
};
export const isLinkPaymentEnabled = ({ commit, rootState }) => {
  const enabled = rootState.system.configuration.enable_link_payments === true;
  commit(types.IS_LINK_PAYMENT_ENABLED, enabled);
};
export const isManualSaleEnabled = ({ commit, rootState }) => {
  const enabled = rootState.system.configuration.enable_manual_sales === true;
  commit(types.IS_MANUAL_SALE_ENABLED, enabled);
};
export const isRecurringPaymentEnabled = ({ commit, rootState }) => {
  const enabled = rootState.system.configuration.enable_recurring_payments === true;
  commit(types.IS_RECURRING_PAYMENT_ENABLED, enabled);
};
export const isRechargeEnabled = ({ commit, rootState }) => {
  const enabled = rootState.system.configuration.enable_recharges === true;
  commit(types.IS_RECHARGE_ENABLED, enabled);
};

export const newLend = ({ commit }, params) => {
  Flowit.payments.newLend(params).then(
    response => {
      commit(types.NEW_LEND, response.data);
      commit(types.NEW_LEND_STATUS, true);
      commit(types.NEW_LEND_ERROR, false);
    },
    error => {
      commit(types.NEW_LEND, error.response.data);
      commit(types.NEW_LEND_ERROR, true);
      commit(types.NEW_LEND_STATUS, false);
    }
  );
};

export const successMessage = ({ commit }, message) => {
  commit(types.SUCCESS_MESSAGE, message);
  commit(types.SUCCESS_STATUS, true);
};

export const errorMessage = ({ commit }, message) => {
  commit(types.ERROR_MESSAGE, message);
  commit(types.ERROR_STATUS, true);
};
